import React from 'react';

const Error404 = () => {
    return ( <div>
                <h1>Error 404</h1>
                <p>La pagina que buscas no existe o fue cambiada de lugar</p>
            </div> );
}
 
export default Error404;